import { Alert, Container, Icon, Table, Button, Modal, Row, Col, TextArea } from "design-react-kit";
import React, { useEffect, useState } from "react";
import { properties } from "../../../config/properties";
import { useLocation,useNavigate } from "react-router-dom";
import InserimentoRuolo from "./inserimentoRuolo";
import Spinner from "../../layout/Spinner";
import SpinnerCustom from "../../layout/Spinner";

// Stili unificati per l'intera pagina
const styles = {
    // NUOVO: Contenitore per la tabella che gestisce lo scroll
    tableContainer: {
        resize: 'vertical',
        minHeight: '20vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)

        height: '70vh', // Imposta un'altezza massima (es. 60% dell'altezza del viewport)
        maxHeight: 'max-content',
        overflowY: 'auto', // Mostra la scrollbar verticale solo se necessario
        // border: '1px solid #e0e0e0',  Bordo sottile per definire l'area di scroll

    },
    // MODIFICATO: Aggiunta delle proprietà per rendere l'header "adesivo"
    tableHeader: {
        borderBottom: '2px solid #dee2e6',
        backgroundColor: '#06c',
        color: 'white',
        textTransform: 'uppercase',
        fontWeight: 600,
        fontSize: '1.25rem',
        letterSpacing: '0.05em',
        // --- Proprietà per lo sticky header ---
        position: 'sticky',
        top: 0, // Si "attacca" al bordo superiore del contenitore di scroll
        zIndex: 1 // Assicura che l'header stia sopra il contenuto della tabella
    },
    tableRowText: {
        color: '#333',
        fontWeight: 500, // Regular/Medium per una migliore leggibilità
        fontSize: "1rem",
        verticalAlign: 'middle', // Allinea verticalmente il testo
        textAlign: "left"
    },
    actionButton: {
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0.5rem'
    },
    formContainer: {
        backgroundColor: '#ffffff',
        padding: '2rem',
        borderRadius: '8px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.07)',
        border: '1px solid #dee2e6'
    },
    formTitle: {
        fontSize: '1.5rem',
        fontWeight: '600',
        color: '#333',
        marginBottom: '1.5rem',
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '0.75rem',
    },
    highlightedRow: {
        backgroundColor: 'rgba(0, 123, 255, 0.1)', // Un blu primario molto leggero e trasparente
        transition: 'background-color 0.3s ease-in-out', // Transizione fluida
    },

};

// Componente per il Form di Modifica (reso riutilizzabile)
const FormModificaRuolo = ({ ruolo, onSave, onCancel,user }) => {
    const [titolo, setTitolo] = useState('');
    const [error, setError] = useState(null);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (ruolo) {
            setTitolo(ruolo.titolo);
        }
    }, [ruolo]);

    const handleConfirm = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setError(null);

        try {


            const response = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/update/ruolo`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ titolo: titolo, id: ruolo.id, userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente})
            });

            if(response.status === 401){

                const datasResponse = await response.json();

                setError("Errore di comunicazione con il server.");

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const result = await response.json();
            if (result.esito === "OK") {
                onSave(); // Notifica il genitore del successo
            } else {
                setError(result.messaggio || "Operazione fallita");
            }
        } catch (err) {
            setError("Errore di rete o server non raggiungibile.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!ruolo) return null;

    return (
        <Container>

        <div style={styles.formContainer}>
            <h2 style={styles.formTitle}>Modifica Ruolo</h2>
            {error && <Alert color="danger">{error}</Alert>}
            <form onSubmit={handleConfirm}>
                <TextArea
                    id="titolo"
                    value={titolo}
                    onChange={(e) => setTitolo(e.target.value)}
                    rows={4}
                    required
                    maxLength={230}
                />
                <div className="mt-4" style={styles.buttonGroup}>
                    <Button className="btn btn-outline-secondary" outline type="button" onClick={onCancel}>
                        Annulla
                    </Button>
                    <Button className="btn btn-outline-primary" type="submit" disabled={isSaving}>
                        {isSaving ? 'Salvataggio...' : 'Salva modifiche'}
                    </Button>
                </div>
            </form>
        </div>
        </Container>
    );
};


const GestioneRuoli = ({user}) => {
    const navigate = useNavigate();

    // --- STATO PRINCIPALE ---
    const [ruoli, setRuoli] = useState([]);
    const [alert, setAlert] = useState({ visible: false, type: '', message: '' });

    // Stato per la gestione del form di modifica
    const [ruoloInModifica, setRuoloInModifica] = useState(null);

    // Stato per la modale di eliminazione
    const [ruoloToDelete, setRuoloToDelete] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [loadingUser, setLoadingUser] = useState(true);

    const location = useLocation();


    // --- FUNZIONI DATI ---
    const fetchRuoli = async () => {

        try{
            const data = await getRuoliList();
            setRuoli(data?.ruoli ?? []);
        }catch(e){
            setRuoli([]);
        }
    };

    useEffect(() => {
        fetchRuoli();
    }, []);

    // Gestisce i messaggi provenienti da altre pagine
    useEffect(() => {
        if (location.state?.esito) {
            setAlert({ visible: false, type: '', message: '' });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const message =  location.state.esito.messaggio ;
            const type = location.state.esito.esito === "OK" ? 'success' : 'danger';
            setAlert({ visible: true, type, message });
        }
    }, [location.state]);

    // --- GESTIONE AZIONI ---
    const handleEditClick = (ruolo) => {
        setRuoloInModifica(ruolo);
        setAlert({ visible: false, type: '', message: '' }); // Nasconde alert precedenti
    };

    const handleCancelEdit = () => {
        setRuoloInModifica(null);
    };

    const handleSaveSuccess = () => {
        setRuoloInModifica(null);
        setAlert({ visible: true, type: 'success', message: 'Ruolo aggiornato con successo!' });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        fetchRuoli(); // Ricarica la lista per mostrare i dati aggiornati
    };

    const openDeleteConfirm = (ruolo) => {
        setRuoloToDelete(ruolo);
        setShowConfirmModal(true);
    };

    const closeDeleteConfirm = () => {
        setRuoloToDelete(null);
        setShowConfirmModal(false);
    };

    const confirmDelete = async () => {

        setAlert({ visible: false, type: '', message: '' });
        if (!ruoloToDelete) return;

        try {
            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/delete/ruolo`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: ruoloToDelete.id , userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente
                }),
            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return;

            }

            const json = await res.json();

            if (json.esito === "OK") {
                setAlert({ visible: true, type: 'success', message: json.messaggio || 'Ruolo eliminato correttamente.' });
                window.scrollTo({ top: 0, behavior: 'smooth' });
                fetchRuoli();
            } else {
                setAlert({ visible: true, type: 'danger', message: json.messaggio || 'Errore durante l\'operazione, non puoi eliminare un ruolo assegnato.' });
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (e) {
            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } finally {
            closeDeleteConfirm();
        }
    };

    // Funzione helper per recuperare i dati
    async function getRuoliList() {
        try {
            //setAlert({ visible: false, type: '', message: '' });
            setLoadingUser(true);

            const res = await fetch(`${properties.fullBaseUrl}${properties.baseAppUrl}/std/service/list/ruoli`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({userID: user.userID, cciaa: user.cciaa, gruppoUtente:user.gruppoUtente}),

            });

            if(res.status === 401){

                const datasResponse = await res.json();

                setAlert({visible: true, type: 'danger', message: 'Errore di comunicazione con il server.'});
                window.scrollTo({top: 0, behavior: 'smooth'});

                setTimeout(() => {
                    window.location.href = datasResponse.redirectUrl;
                }, 10);

                return[];

            }

            if (!res.ok) throw new Error("Errore HTTP");
            return await res.json();
        } catch (e) {
            setAlert({ visible: true, type: 'danger', message: 'Errore di rete o server non raggiungibile.' });
            return []; // Ritorna un array vuoto in caso di errore
        }finally {
            setLoadingUser(false);
        }
    }

    if (loadingUser) {
        // Puoi mostrare uno spinner o scritta di caricamento


        return (

            <Container fluid className="vh-100 d-flex justify-content-center align-items-center bg-light">

                <p className="mb-3">
                    <strong>
                        Caricamento
                    </strong>
                </p>
                <SpinnerCustom active/>


            </Container>
        );


    }

    // --- RENDER ---
    return (
        <div className="bg-white py-5 py-lg-6">
            <Container>
                <h2 className="mb-5 ">Gestione Ruoli</h2>

                {alert.visible && (
                    <Alert color={alert.type} isOpen={alert.visible} toggle={() => setAlert({ ...alert, visible: false })}>
                        {alert.message}
                    </Alert>
                )}

                <Row>
                    {/* COLONNA SX: FORM MODIFICA (visibile condizionalmente) */}

                    {(
                        <Col md={5} hidden={ruoloInModifica} className="transition-all duration-300">
                            <Container>

                                <div className="guidance-box lead">
                                    <p>
                                        Crea un nuovo profilo utente per modellare l'esperienza sulla nostra
                                        piattaforma. Inizia con un nome chiaro e rappresentativo per il ruolo, poi cura
                                        l'ordinamento di essi se desiderato.
                                    </p>

                                    <div style={{display:'flex'}}>
                                        <div style={{flex:1, padding:"1.68%"}} align={"right"}>
                                            <Button color="primary" outline onClick={() => {
                                                navigate('/private/inserimentoRuolo')
                                            }}> Inserisci Ruolo</Button>
                                        </div>
                                        <div style={{flex:1, padding:"1.68%"}} align={"left"}>
                                            <Button color="secondary" outline onClick={() => {
                                                navigate('/private/ordinamentoRuoli')
                                            }}>Ordina i Ruoli</Button>
                                        </div>

                                    </div>



                                </div>



                            </Container>
                        </Col>
                    )}

                    {/* COLONNA DX: TABELLA RUOLI */}
                    <Col md={ruoloInModifica ? 8 : 7} className="transition-all duration-300">

                            <Table hover className="border-0" >
                            <thead >
                            <tr >
                                <th scope="col" className="text-left" style={styles.tableHeader}>Ruolo</th>
                                <th scope="col" className="text-left" style={{...styles.tableHeader, width: '15%'}}>Azioni</th>
                            </tr>
                            </thead>
                            </Table>
                        <div className="custom-scrollbar" style={styles.tableContainer}>

                        <Table hover className="border-0" >

                            <tbody>
                            {ruoli.length > 0 ? (
                                ruoli.map((ruolo, index) => {

                                    // 1. Controlla se questa è la riga da evidenziare
                                    const isHighlighted = ruoloInModifica && ruolo.id === ruoloInModifica.id;

                                    return (
                                        // 2. Applica lo stile alla <tr> se isHighlighted è true
                                        <tr key={ruolo.id} style={isHighlighted ? styles.highlightedRow : undefined}>

                                            {/* 3. Stili di testo applicati correttamente alle celle */}
                                            <td className="text-left" style={styles.tableRowText}>{ruolo.titolo}</td>

                                            <td className="text-left" style={{...styles.tableRowText, width: '15%'}} >
                                                <button className={"action-icon"} style={styles.actionButton} onClick={() => handleEditClick(ruolo)} aria-label={`Modifica ${ruolo.titolo}`}>
                                                    <Icon icon="it-pencil" color="primary" />
                                                </button>
                                                <button className={"action-icon"} style={styles.actionButton} onClick={() => openDeleteConfirm(ruolo)} aria-label={`Elimina ${ruolo.titolo}`}>
                                                    <Icon icon="it-delete" color="danger" />
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="2" style={styles.tableRowText}>Nessun ruolo presente.</td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                        </div>

                        {ruoli.length > 0 && (
                            <>
                                <Row className="mt-2">
                                    <Col className="text-end">
                                        <small className="text-muted">
                                            <strong>{ruoli.length}</strong>  risultati
                                        </small>
                                    </Col>
                                </Row>

                            </>
                        )}
                        </Col>
                    {/* COLONNA SX: FORM MODIFICA (visibile condizionalmente) */}

                    {ruoloInModifica && (
                        <Col md={4} className="transition-all duration-900">
                            <FormModificaRuolo
                                ruolo={ruoloInModifica}
                                onSave={handleSaveSuccess}
                                onCancel={handleCancelEdit}
                                user={user}
                            />
                        </Col>
                    ) }

                </Row>
                <Spinner active = {!setRuoli}/>

            </Container>

            {/* MODALE DI CONFERMA ELIMINAZIONE */}
            <Modal isOpen={showConfirmModal} toggle={closeDeleteConfirm} centered>
                <div toggle={closeDeleteConfirm}>Conferma Eliminazione</div>
                <div>
                    Sei sicuro di voler eliminare il ruolo: <strong>{ruoloToDelete?.titolo}</strong>?
                    <br />
                    L'azione non potrà essere annullata.
                </div>
                <div>
                    <Button color="secondary" outline onClick={closeDeleteConfirm}>Annulla</Button>
                    &nbsp;
                    <Button color="danger" onClick={confirmDelete}>Conferma ed Elimina</Button>
                </div>
            </Modal>
        </div>
    );
}



export default GestioneRuoli;